import { useTranslation } from "react-i18next";

/**
 * Translated "circuit of 3" / "single exercise" + "joins this circuit" /
 * "outside this circuit" lines for an insert view (see describeInsert).
 */
export const getInsertContextParts = (t, view) => {
  const circuitText = view.targetIsComplex
    ? t("programs.insert.complexRow")
    : view.inCircuit
      ? t("programs.insert.circuitOf", { count: view.circuitSize })
      : t("programs.insert.singleExercise");
  const joinText = view.inCircuit
    ? t(
        view.join
          ? "programs.insert.joinsCircuit"
          : "programs.insert.outsideCircuit"
      )
    : null;
  return { circuitText, joinText };
};

/**
 * Above / Below switch plus the target exercise (letter + name) with its
 * circuit context. Shared by the Add Exercise queue panel and the Import
 * Workout modal.
 *
 * @param {object} props
 * @param {"above"|"below"} props.position
 * @param {Function} props.onPositionChange
 * @param {string} props.targetLetter letter the target will have after the insert
 * @param {string} props.targetName
 * @param {object} props.view result of describeInsert
 * @param {string} [props.contextPrefix] e.g. "Week 2 · Workout 3", shown before the circuit text
 */
const InsertPositionCard = ({
  position,
  onPositionChange,
  targetLetter,
  targetName,
  view,
  contextPrefix,
}) => {
  const { t } = useTranslation("athlete-portal");
  const { circuitText, joinText } = getInsertContextParts(t, view);

  return (
    <div className="insert-card">
      <div className="insert-segment" title={t("programs.insert.position")}>
        {["above", "below"].map((value) => (
          <button
            key={value}
            type="button"
            aria-pressed={position === value}
            className={position === value ? "insert-segment-on" : ""}
            onClick={() => position !== value && onPositionChange(value)}
          >
            <span>{t(`programs.insert.${value}`)}</span>
          </button>
        ))}
      </div>
      <div className="insert-target">
        <span className="insert-target-label">
          {t("programs.insert.targetExercise")}
        </span>
        <div className="insert-target-row">
          <span className="calendar-prefix">{targetLetter}</span>
          <span className="insert-target-name">{targetName}</span>
        </div>
        <p className="insert-target-context">
          {[contextPrefix, circuitText].filter(Boolean).join(" · ")}
          {joinText && (
            <span
              className={`insert-join${view.join ? " insert-join-on" : ""}`}
            >
              {joinText}
            </span>
          )}
        </p>
      </div>
    </div>
  );
};

export default InsertPositionCard;
